import { extractApiErrorMessages } from '@app/utilities/api-error.util';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { Component, OnInit } from "@angular/core";
import { AppointmentService } from "@app/core/services";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl:"./cancel-booking.component.html",
    styleUrls:["./cancel-booking.component.css"]
})
export class CancelBookingComponent implements OnInit{

    constructor(public activeModal: NgbActiveModal,
        private toastrService: ToastrService,
        private translate: TranslateService,
        public appointmentService: AppointmentService
        ) {}
    ngOnInit(): void {
    }
    
    public cancellationReason:string;
    public bookingId: number;

    public isSaving = false;

    cancel(){
        if (this.isSaving) return;
        this.isSaving = true;
        this.appointmentService.cancelAppointments({appointmentId:this.bookingId,cancellationReason:this.cancellationReason})
          .pipe(finalize(() => this.isSaving = false))
          .subscribe({
            next: res => this.activeModal.close(res),
            error: error => this.toastrService.error(
              extractApiErrorMessages(error).join('\n') || this.translate.instant('general.error_message'),
              this.translate.instant('general.error_message')
            )
          });
          
    }
}